export const rankReducer = (state, action) => {
  switch (action.type) {
    case "loadRanks":
      console.log("loading Rank");
      return loadRank(state, action.ranks);
    case "disableRank":
      return;
    default:
      return state;
  }
};

const loadRank = (state, ranks) => {
  debugger;
  console.log("Loading ranks");
  console.log(ranks);
  let newState = [...ranks];

  return newState;

  //console.log(curriculum.data.curriculums);
};

const disableRank = (state, rankId) => {
  const newState = [...state];
  const index = newState.findIndex((r) => r.rankId == rankId);
  newState[index] = {
    ...newState[index],
    disabled: !newState[index].disbaled,
  };
  return newState;
};
